import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['display', 'until']
  static values = {
    until: String,
    permanent: Boolean
  }

  connect () {
    if (this.permanentValue) return

    this.tick()
    this.timer = window.setInterval(() => this.tick(), 1000)
  }

  disconnect () {
    if (this.timer) window.clearInterval(this.timer)
  }

  tick () {
    if (!this.hasDisplayTarget || !this.untilValue) return

    const end = Date.parse(this.untilValue)
    if (Number.isNaN(end)) return

    const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000))
    this.displayTarget.textContent = this.format(seconds)

    if (seconds === 0 && this.hasUntilTarget) {
      this.untilTarget.textContent = 'Restriction lifting now…'
    }
  }

  format (totalSeconds) {
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const parts = []
    if (days > 0) parts.push(`${days}d`)
    if (hours > 0 || days > 0) parts.push(`${hours}h`)
    parts.push(`${minutes}m`)
    parts.push(`${String(seconds).padStart(2, '0')}s`)

    return parts.join(' ')
  }
}
